import clgbrown from '../Image/clgbrown1.jpg'
function Third(){
    return( <div>
        <img alt='' src={clgbrown} className='clgbrown'></img>
       <p className='wel'>Well-Come!!</p>
            
        </div>
        );
}
export default Third;